'use client'

import {useInView} from 'react-intersection-observer'
import BracketSVG from '@local/assets/svgs/bracket.svg'
import {cx} from '@local/utils/cx'
import {ScrollAnimation} from '@local/ui/components'
import {useEffect} from 'react'

export const CommunityHeroContent = ({title, index}) => {
	const HeadingTag = index === 0 ? 'h1' : 'h2'

	const [inViewRef, inView] = useInView({
		threshold: 0,
		initialInView: true,
	})

	useEffect(() => {
		document.body.classList.add('bg-transparent')
	}, [])

	return (
		<>
			<div ref={inViewRef}>
				<ScrollAnimation
					y={70}
					className='z-1 flex justify-between items-center span-w-12 lg:span-w-6 text-white lg:mb-50'>
					<BracketSVG className='span-w-1-wide h-auto lg:h-120 lg:w-auto' />
					<HeadingTag className='text-28 lg:text-34 text-center capitalize font-serif leading-snug lg:leading-tight tracking-tighter font-medium text-white'>{title}</HeadingTag>
					<BracketSVG className='span-w-1-wide h-auto lg:h-120 lg:w-auto -scale-x-100' />
				</ScrollAnimation>
			</div>
			<div
				className={cx(
					'fixed inset-0 w-full h-full top-0',
					'transition-color duration-700 ease-quint-out -z-1',
					!inView ? 'bg-white-off' : 'bg-grey-4',
				)} />
		</>
	)
}
